import React from "react";
import Test from "./test";

const info = {
  difficulty: "easy",
  title: "Two Sum",
  url: "two-sum",
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {number[]} nums
* @param {number} target
* @return {boolean}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function twoSum(nums, target) {
  // your code goes here        
};
`,
};

export default info;
